import React from "react";
import { PuffLoader } from "react-spinners";

const ModalButton = ({ className, label, onClick, loading = false, disabled = false, isActive = true, ...props }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled || loading}
            className={`
        tw-relative
        tw-w-full sm:tw-w-1/2
        tw-flex tw-flex-row tw-justify-center tw-items-center 
        tw-px-6 tw-py-3 sm:tw-px-[20px] sm:tw-py-[18px] tw-gap-2 
        tw-rounded-[12px] sm:tw-rounded-[30px]
        tw-font-[450] 
        tw-text-[16px] sm:tw-text-[15px] 
        tw-leading-[140%]
        tw-[box-shadow:17px_13px_18px_rgba(0,126,197,0.14)]
        ${disabled || !isActive
                    ? "tw-bg-[#D1D5DB] tw-text-[#8791A2] tw-cursor-not-allowed"
                    : "tw-bg-gradient-to-r tw-from-[#549A9C] tw-to-[#65ACAE] disabled:tw-cursor-not-allowed tw-text-white hover:tw-text-black hover:tw-opacity-95"}
        ${className}
        
                    `}
            {...props}
        >
            {loading ? <PuffLoader color="white" size={22} className="mx-auto" /> : label}
        </button>
    );
};

export default ModalButton;
